import React, { Component } from 'react';
import zxcvbn from 'zxcvbn';
import TextMap from '../../helpers/TextMap';

import './PasswordSecurity.scss';

export default class PasswordSecurity extends Component {
  constructor(props) {
    super(props);
    this.state = {
      score: null,
      suggestions: [],
      warning: '',
    };

    this.textMap = new TextMap();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.password1 != this.props.password1) {
      this.testPasswordStrength();
    }
  }

  testPasswordStrength() {
    const { password1, updatePasswordStrength } = this.props;

    let passwordResults, warning;
    let passwordSuggestions = [];

    if (password1.length > 0) {
      passwordResults = zxcvbn(password1);
      if (passwordResults.feedback.suggestions.length > 0) {
        passwordSuggestions = passwordResults.feedback.suggestions;
      }
      warning = passwordResults.feedback.warning;
    }

    let score = passwordResults ? parseInt(passwordResults.score, 10) : 0;
    
    this.setState({
      suggestions: passwordSuggestions,
      score: score,
      warning: warning,
    });

    if (updatePasswordStrength) {
      updatePasswordStrength(score >= 3);
    }
  }

  determineStrength() {
    const { password1 } = this.props;
    const { score } = this.state;

    if (password1) {
      let class1, class2, class3;
      let indicatorText;
      let color;
      switch (score) {
      case 0:
      case 1:
        indicatorText = 'Weak';
        class1 = 'red';
        class2 = 'grey';
        class3 = 'grey';
        color = '#cd030a';
        break;
      case 2:
        indicatorText = 'Almost';
        class1 = 'red';
        class2 = 'red';
        class3 = 'grey';
        color = '#cd030a';
        break;
      case 3:
      case 4:
      case 5:
      case 6:
        indicatorText = 'Strong';
        class1 = 'green';
        class2 = 'green';
        class3 = 'green';
        color = '#5db348';
        break;
      default:
        break;
      }
      return (
        <div className="visual-indicator-container">
          <div className={'bar ' + class1} />
          <div className={'bar ' + class2} />
          <div className={'bar ' + class3} />
          <div className="indicator-text" style={{ color: color }}>
            {indicatorText}
          </div>
        </div>
      );
    }
  }

  createSuggestions() {
    const { suggestions, warning } = this.state;

    if (suggestions.length) {
      let i = 0;
      let passSuggestions = suggestions.map(suggestion => {
        i++;
        return (
          <div key={`suggestion-${i}`} className="password-suggestion">
            {suggestion}
          </div>
        );
      });

      if (warning) {
        passSuggestions.unshift(
          <div key={`suggestion-${i + 1}`} className="password-suggestion">
            {warning}
          </div>
        );
      }

      return (
        <div className="password-suggestions-container">{passSuggestions}</div>
      );
    }
  }

  determineLength() {
    const { password1 } = this.props;

    if (password1.length && password1.length < 8) {
      return  <div className='error-message'>{this.textMap.password8Characters}</div>;
    }
  }

  render() {
    const { containerWidthClass } = this.props;

    return (
      <div className={'password-strength-container' + (containerWidthClass ? ' password-strength-container' + containerWidthClass : '')}>
        { this.determineLength() }
        { this.determineStrength() }
        { this.createSuggestions() }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/PasswordSecurity/index.js